// Mock data para la página de turismo de Guachucal

export const heroData = {
  title: "Vía Láctea Guachucal",
  subtitle: "Descubre la magia del municipio lechero en el corazón de los Andes",
  videoUrl: "https://www.youtube.com/watch?v=foEDBzmvk2U", // Mock video URL
  dailyLitersProcessed: 3186,
  whatsappNumber: "+573215654899"
};

export const valueProps = [
  {
    icon: "img/lechefresca1.jpg",
    title: "Leche Fresca",
    description: "Directo del ordeño al amanecer, con la frescura de los páramos andinos"

  },
  {
    icon: "img/paisajeandino1.jpg", 
    title: "Paisaje Andino",
    description: "Volcanes, frailejones y una vista espectacular de la cordillera"
  },
  {
    icon: "img/cieloestrellado.png", 
    title: "Cielo Oscuro",
    description: "Uno de los mejores lugares para la observación de estrellas en Colombia"
  }
];

export const experienceTimeline = [
  {
    time: "5:30 AM",
    title: "Ordeño al Amanecer",
    description: "Participa en el ordeño matutino y conecta con la tradición ganadera",
    image: "img/ordeño.jpg",
    tip: "Lleva ropa cómoda y abrigada para la madrugada"
  },
  {
    time: "9:00 AM",
    title: "Taller de Quesillo",
    description: "Aprende a hacer quesillo artesanal con técnicas tradicionales",
    image: "img/quesillo.jpg", 
    tip: "Podrás llevarte a casa el queso que hagas"
  },
  {
    time: "2:00 PM",
    title: "Miradores de Volcanes",
    description: "Caminata a los mejores puntos de vista del Galeras y Cumbal",
    image: "img/mirador.jpg",
    tip: "No olvides tu cámara para capturar el paisaje"
  },
  {
    time: "7:00 PM",
    title: "Cena Fogatera & Astroturismo",
    description: "Degusta comida típica bajo un manto de estrellas",
    image: "img/fogata.jpg",
    tip: "La contaminación lumínica es mínima, ideal para stargazing"
  }
];

export const dairyProcessors = [
  {
    name: "Lácteos la Realeza",
    description: "Planta procesadora láctea dedicada a la producción artesanal de quesos de alta calidad, elaborados con leche fresca del altiplano nariñense",
    stats: "Especialistas en una amplia variedad de quesos y productos derivados",
    certifications: ["INVIMA", "BPM", "ISO 9001"],
    image: "img/realeza.jpg"
  },
  {
    name: "Hotel Nalhoa Real",
    description: "Un acogedor hotel ubicado en lo alto del municipio, rodeado de paisajes únicos y aire puro de montaña. Ideal para descansar, disfrutar de la tranquilidad y conectar con la naturaleza.",
    stats: "Habitaciones confortables para todos los gustos y necesidades",
    certifications: ["NTS-TS 001-2", "Registro Turístico", "FONTUR"],
    image: "img/nalhoa.jpg"
  },
  {
    name: "Anuc",
    description: "Asociación Nacional de usuarios campesinos",
    stats: "Fortaleciendo el campo a través de la unión y el trabajo colectivo",
    certifications: ["Personería Jurídica", "NTS-AV 001"],
    image: "img/anuc.png"
  }
];

export const testimonials = [
  {
    name: "María González",
    location: "Bogotá",
    rating: 5,
    comment: "Una experiencia increíble. El amanecer en la finca y el queso artesanal fueron espectaculares.",
    video: "https://www.youtube.com/watch?v=foEDBzmvk2U",
    avatar: null
  },
  {
    name: "Carlos Ramírez",
    location: "Medellín",
    rating: 5,
    comment: "El astroturismo superó mis expectativas. Nunca había visto tantas estrellas.",
    video: "https://www.youtube.com/watch?v=foEDBzmvk2U",
    avatar: null
  },
  {
    name: "Ana Lucia Torres",
    location: "Cali",
    rating: 5,
    comment: "Perfecto para desconectarse. La hospitalidad de la gente es excepcional.",
    video: "https://www.youtube.com/watch?v=foEDBzmvk2U",
    avatar: null
  }
];

export const events = [
  {
    name: "Reina del Queso",
    date: "2025-10-11",
    description: "Celebración anual de la tradición quesera con concursos, degustaciones y música en vivo",
    image: "img/reinado.png",
    countdown: true
  },
  {
    name: "Exposición de productos lacteos", 
    date: "2025-10-12",
    description: "Exposición de productos lácteos de la región",
    image: "img/stands.jpg",
    countdown: false
  },
  {
    name: "Presentación Musical",
    date: "2025-10-12", 
    description: "Presentación muscical de diferentes agrupaciones artisiticas",
    image: "img/marabu.jpg", 
    countdown: false
  }
];

export const iotData = {
  tankTemperature: 4.2,
  pH: 6.8,
  lastUpdate: "2024-01-15T08:30:00Z"
};

export const weatherData = {
  temperature: 12,
  humidity: 78,
  moonPhase: "Cuarto creciente",
  conditions: "Despejado"
};

export const contactInfo = {
  phone: "+57 321 565 4899",
  email: "guachucalrutaagroturistica@gmail.com",
  whatsapp: "+573215654899",
  address: "Guachucal, Nariño, Colombia"
};